/* Boivin Leather - add-to-cart pop-up (Visionary upgrade + refill offer + refill Subscribe & Save) */
(function () {
  const cfgEl = document.getElementById('atc-popup-config');
  if (!cfgEl) return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  const money = (cents) => {
    const d = cents / 100;
    return '$' + (Number.isInteger(d) ? d : d.toFixed(2));
  };
  const sameOptions = (a, b) => a.length === b.length && a.every((o, i) => o === b[i]);
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- styles ---------- */
  const css = `
  .atcp-overlay{position:fixed;inset:0;background:rgba(18,18,18,.55);z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;opacity:0;transition:opacity .2s ease}
  .atcp-overlay.is-open{opacity:1}
  @media(min-width:750px){.atcp-overlay{align-items:center}}
  .atcp{background:rgb(var(--color-background,255,255,255));color:rgb(var(--color-foreground,18,18,18));width:100%;max-width:460px;max-height:92vh;overflow:auto;border-radius:14px 14px 0 0;padding:24px 20px 20px;position:relative;transform:translateY(20px);transition:transform .2s ease;box-shadow:0 10px 40px rgba(0,0,0,.25)}
  @media(min-width:750px){.atcp{border-radius:14px;padding:28px}}
  .atcp-overlay.is-open .atcp{transform:none}
  .atcp__close{position:absolute;top:10px;right:10px;width:36px;height:36px;border:0;background:none;font-size:24px;line-height:1;cursor:pointer;color:inherit;opacity:.7}
  .atcp__eyebrow{font-size:1.1rem;letter-spacing:.12em;text-transform:uppercase;opacity:.7;margin:0 0 6px}
  .atcp__title{font-family:var(--font-heading-family);font-size:2.2rem;line-height:1.2;margin:0 0 14px}
  .atcp__row{display:flex;gap:14px;align-items:center;margin-bottom:14px}
  .atcp__img{width:96px;height:96px;flex:0 0 96px;border-radius:8px;object-fit:cover;background:rgba(var(--color-foreground,18,18,18),.05)}
  .atcp__name{font-weight:600;font-size:1.5rem;margin:0 0 4px}
  .atcp__price{font-size:1.5rem;margin:0}
  .atcp__price s{opacity:.55;margin-right:6px}
  .atcp__badge{display:inline-block;font-size:1.1rem;font-weight:600;padding:2px 8px;border-radius:20px;background:rgb(var(--color-foreground,18,18,18));color:rgb(var(--color-background,255,255,255));margin-left:6px;vertical-align:middle}
  .atcp__perks{list-style:none;padding:0;margin:0 0 18px}
  .atcp__perks li{font-size:1.4rem;padding:4px 0 4px 22px;position:relative}
  .atcp__perks li:before{content:"\\2713";position:absolute;left:0;font-weight:700}
  .atcp__label{font-size:1.3rem;margin:0 0 8px;opacity:.8}
  .atcp__chips{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:18px}
  .atcp__chip{border:1px solid rgba(var(--color-foreground,18,18,18),.35);background:none;color:inherit;border-radius:40px;padding:8px 16px;font-size:1.4rem;cursor:pointer}
  .atcp__chip[aria-pressed="true"]{border-color:rgb(var(--color-foreground,18,18,18));background:rgb(var(--color-foreground,18,18,18));color:rgb(var(--color-background,255,255,255))}
  .atcp__actions{display:flex;flex-direction:column;gap:10px}
  .atcp__actions .button{width:100%;margin:0}
  .atcp__link{background:none;border:0;color:inherit;text-decoration:underline;font-size:1.4rem;cursor:pointer;padding:6px;opacity:.8}
  .atcp__note{font-size:1.2rem;opacity:.65;text-align:center;margin:10px 0 0}
  body.atcp-lock{overflow:hidden}
  .atcp__plans{display:flex;flex-direction:column;gap:10px;margin-bottom:16px}
  .atcp__plan{display:flex;align-items:center;gap:12px;width:100%;text-align:left;border:1px solid rgba(var(--color-foreground,18,18,18),.3);background:none;color:inherit;border-radius:10px;padding:12px 14px;cursor:pointer;font:inherit}
  .atcp__plan[aria-pressed="true"]{border:2px solid rgb(var(--color-foreground,18,18,18));padding:11px 13px}
  .atcp__dot{width:18px;height:18px;flex:0 0 18px;border-radius:50%;border:1.5px solid currentColor;position:relative}
  .atcp__plan[aria-pressed="true"] .atcp__dot:after{content:"";position:absolute;inset:3px;border-radius:50%;background:currentColor}
  .atcp__plan-main{flex:1;min-width:0}
  .atcp__plan-name{font-weight:600;font-size:1.4rem;display:block}
  .atcp__plan-sub{font-size:1.2rem;opacity:.7;display:block;margin-top:2px}
  .atcp__plan-price{font-size:1.4rem;text-align:right;white-space:nowrap}
  .atcp__plan-price s{opacity:.5;font-size:1.2rem;display:block}
  .atcp__flex{display:flex;justify-content:center;gap:14px;flex-wrap:wrap;font-size:1.2rem;opacity:.75;margin:12px 0 0}
  @media(max-width:749px){.atcp{padding-bottom:calc(16px + env(safe-area-inset-bottom))}.atcp__img{width:72px;height:72px;flex-basis:72px}.atcp__title{font-size:2rem;margin-bottom:12px}.atcp__row{margin-bottom:10px}.atcp__perks{margin-bottom:14px}.atcp__perks li{padding:3px 0 3px 22px}.atcp__chips{margin-bottom:14px}}
  `;
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  /* ---------- modal shell ---------- */
  let overlay, box, lastFocus, onDismiss;
  function open(html) {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'atcp-overlay';
      overlay.innerHTML = '<div class="atcp" role="dialog" aria-modal="true" aria-labelledby="atcp-title"></div>';
      box = overlay.firstChild;
      overlay.addEventListener('click', (e) => { if (e.target === overlay) dismiss(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && overlay.isConnected) dismiss(); });
    }
    box.innerHTML = '<button type="button" class="atcp__close" aria-label="Close">&times;</button>' + html;
    box.querySelector('.atcp__close').addEventListener('click', dismiss);
    if (!overlay.isConnected) {
      lastFocus = document.activeElement;
      document.body.appendChild(overlay);
      document.body.classList.add('atcp-lock');
      requestAnimationFrame(() => overlay.classList.add('is-open'));
    }
    const first = box.querySelector('.button');
    if (first) first.focus();
  }
  function close() {
    if (!overlay || !overlay.isConnected) return;
    overlay.classList.remove('is-open');
    document.body.classList.remove('atcp-lock');
    overlay.remove();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function dismiss() { if (onDismiss) onDismiss(); }

  /* ---------- steps ---------- */
  function upgradeStep(current, target) {
    return new Promise((resolve) => {
      onDismiss = () => resolve(false);
      const diff = target.price - current.price;
      const perks = (cfg.upgrade.perks || []).map((p) => `<li>${esc(p)}</li>`).join('');
      open(`
        <p class="atcp__eyebrow">Before you add it</p>
        <h2 class="atcp__title" id="atcp-title">Want more pockets?</h2>
        <div class="atcp__row">
          <img class="atcp__img" src="${esc(target.image || '')}" alt="" loading="lazy">
          <div>
            <p class="atcp__name">${esc(cfg.upgrade.title)} <span style="opacity:.6;font-weight:400">&middot; ${esc(target.options.join(' / '))}</span></p>
            <p class="atcp__price">${money(target.price)} <span class="atcp__badge">+${money(diff)}</span></p>
          </div>
        </div>
        <ul class="atcp__perks">${perks}</ul>
        <div class="atcp__actions">
          <button type="button" class="button" data-yes>Switch to ${esc(cfg.upgrade.title)}</button>
          <button type="button" class="atcp__link" data-no>Keep the ${esc(cfg.product.title)}</button>
        </div>`);
      box.querySelector('[data-yes]').addEventListener('click', () => resolve(true));
      box.querySelector('[data-no]').addEventListener('click', () => resolve(false));
    });
  }

  function refillStep(choices) {
    return new Promise((resolve) => {
      onDismiss = () => resolve(null);
      const r = cfg.refill;
      const price = choices[0].price;
      const sale = Math.round(price * (100 - r.discount) / 100);
      const size = choices[0].options[0];
      let picked = choices[0];
      try { sessionStorage.setItem('blr_refill_offered', '1'); } catch (e) {}
      const chips = choices.map((v, i) =>
        `<button type="button" class="atcp__chip" data-i="${i}" aria-pressed="${i === 0}">${esc(v.options[2] || v.options.join(' / '))}</button>`).join('');
      open(`
        <p class="atcp__eyebrow">Pairs with your journal</p>
        <h2 class="atcp__title" id="atcp-title">Get your notebook refills ${r.discount}% off</h2>
        <div class="atcp__row">
          <img class="atcp__img" src="${esc(r.image || '')}" alt="" loading="lazy">
          <div>
            <p class="atcp__name">${esc(r.title)} &middot; ${esc(size)} ${esc(r.pack)}</p>
            <p class="atcp__price"><s>${money(price)}</s>${money(sale)} <span class="atcp__badge">${r.discount}% off</span></p>
          </div>
        </div>
        <p class="atcp__label">Choose your paper</p>
        <div class="atcp__chips">${chips}</div>
        <div class="atcp__actions">
          <button type="button" class="button" data-yes>Add refills for ${money(sale)}</button>
          <button type="button" class="atcp__link" data-no>No thanks, just the journal</button>
        </div>
        <p class="atcp__note">Discount applies automatically at checkout.</p>`);
      box.querySelectorAll('.atcp__chip').forEach((b) => b.addEventListener('click', () => {
        box.querySelectorAll('.atcp__chip').forEach((x) => x.setAttribute('aria-pressed', 'false'));
        b.setAttribute('aria-pressed', 'true');
        picked = choices[Number(b.dataset.i)];
      }));
      box.querySelector('[data-yes]').addEventListener('click', () => resolve(picked));
      box.querySelector('[data-no]').addEventListener('click', () => resolve(null));
    });
  }

  function subscribeStep(current) {
    return new Promise((resolve) => {
      onDismiss = () => resolve(null);
      const plans = (cfg.subscribe.plans || []).filter((p) => !/journal starter/i.test(p.name)).map((p) => {
        const alloc = (current.plans || []).find((a) => a.id === p.id);
        return alloc ? Object.assign({}, p, { price: alloc.price }) : null;
      }).filter(Boolean);
      if (!plans.length) return resolve(null);
      try { sessionStorage.setItem('blr_sub_offered', '1'); } catch (e) {}
      const best = Math.max.apply(null, plans.map((p) => p.pct));
      let picked = plans[0];
      const label = (p) => p.name;
      const sub = (p) => {
        const d = (p.description || '').split('·')[1];
        return d ? d.trim() : (p.description || '');
      };
      const cards = plans.map((p, i) => `
        <button type="button" class="atcp__plan" data-i="${i}" aria-pressed="${i === 0}">
          <span class="atcp__dot" aria-hidden="true"></span>
          <span class="atcp__plan-main"><span class="atcp__plan-name">${esc(label(p))} &middot; save ${p.pct}%</span><span class="atcp__plan-sub">${esc(sub(p))}</span></span>
          <span class="atcp__plan-price"><s>${money(current.price)}</s>${money(p.price)}</span>
        </button>`).join('');
      open(`
        <p class="atcp__eyebrow">Never run out of paper</p>
        <h2 class="atcp__title" id="atcp-title">Subscribe &amp; save up to ${best}%</h2>
        <div class="atcp__row">
          <img class="atcp__img" src="${esc(current.image || cfg.product.image || '')}" alt="">
          <div>
            <p class="atcp__name">${esc(cfg.product.title)}</p>
            <p class="atcp__price" style="opacity:.75">${esc(current.options.join(' / '))}</p>
          </div>
        </div>
        <div class="atcp__plans">${cards}</div>
        <div class="atcp__actions">
          <button type="button" class="button" data-yes>Subscribe &amp; save</button>
          <button type="button" class="atcp__link" data-no>No thanks, one-time purchase</button>
        </div>
        <p class="atcp__flex"><span>&#8635; Skip</span><span>&#10073;&#10073; Pause</span><span>&#10005; Cancel anytime</span></p>`);
      box.querySelectorAll('.atcp__plan').forEach((b) => b.addEventListener('click', () => {
        box.querySelectorAll('.atcp__plan').forEach((x) => x.setAttribute('aria-pressed', 'false'));
        b.setAttribute('aria-pressed', 'true');
        picked = plans[Number(b.dataset.i)];
      }));
      box.querySelector('[data-yes]').addEventListener('click', () => resolve(picked));
      box.querySelector('[data-no]').addEventListener('click', () => resolve(null));
    });
  }

  /* ---------- intercept add to cart ---------- */
  let bypass = false;
  let busy = false;

  async function cartHasRefill() {
    if (!cfg.refill) return false;
    try {
      const res = await fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      return cart.items.some((i) => i.product_id === cfg.refill.productId);
    } catch (e) { return false; }
  }

  function submitNative(form) {
    bypass = true;
    try {
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    } finally { bypass = false; }
  }

  document.addEventListener('submit', async (e) => {
    if (bypass || busy) return;
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('product-form')) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    const idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    const originalId = Number(idInput.value);
    const current = cfg.product.variants.find((v) => v.id === originalId);
    if (!current) return; // some other product's form (e.g. quick add)
    const btn = form.querySelector('[type="submit"]');
    if (btn && (btn.getAttribute('aria-disabled') === 'true' || btn.disabled)) return;

    /* Refill page: offer Subscribe & Save on one-time adds */
    if (cfg.subscribe) {
      const planInput = form.querySelector('[name="selling_plan"]');
      if (planInput && planInput.value) return; // already chose a subscription
      if (!current.plans || !current.plans.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      busy = true;
      let input = planInput;
      let created = false;
      try {
        const plan = await subscribeStep(current);
        close();
        if (plan) {
          if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'selling_plan'; form.appendChild(input); created = true; }
          input.value = plan.id;
        }
        submitNative(form);
      } finally {
        busy = false;
        setTimeout(() => { if (input) { if (created) input.remove(); else input.value = ''; } }, 0);
      }
      return;
    }

    const target = cfg.upgrade && cfg.upgrade.variants.find((v) => v.available && sameOptions(v.options, current.options));
    if (!target && !cfg.refill) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    busy = true;

    try {
      let chosenOptions = current.options;
      if (target) {
        const yes = await upgradeStep(current, target);
        if (yes) { idInput.value = target.id; chosenOptions = target.options; }
      }

      let refillPick = null;
      if (cfg.refill && !(await cartHasRefill())) {
        const choices = cfg.refill.variants.filter((v) => v.available && v.options[0] === chosenOptions[0] && v.options[1] === cfg.refill.pack);
        if (choices.length) refillPick = await refillStep(choices);
      }
      close();

      if (refillPick) {
        try {
          await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: refillPick.id, quantity: 1 }] }),
          });
        } catch (err) { console.error('[atc-popup] refill add failed', err); }
      }

      submitNative(form); // adds the journal and opens the cart drawer as normal
    } finally {
      busy = false;
      // put the page's variant back so the Studio/Archive page isn't left pointing at Visionary
      setTimeout(() => { if (Number(idInput.value) !== originalId) idInput.value = originalId; }, 0);
    }
  }, true);
})();
